import React from 'react';
import './Services.css';
import useRevealOnScroll from '../utils/useRevealOnScroll';
import {
  FaUtensils,
  FaCocktail,
  FaBeer,
  FaCoffee,
  FaStore,
  FaMapMarkerAlt
} from 'react-icons/fa';

const items = [
  { icon: <FaUtensils />, title: 'Restaurants' },
  { icon: <FaCocktail />, title: 'Bars' },
  { icon: <FaBeer />, title: 'Pubs' },
  { icon: <FaStore />, title: 'Tapris' },
  { icon: <FaCoffee />, title: 'Cafés' },
  { icon: <FaMapMarkerAlt />, title: 'Local food spots' }
];

export default function Services() {
  const { ref, isVisible } = useRevealOnScroll({ rootMargin: '0px 0px -8% 0px' });

  return (
    <section className={isVisible ? 'section services2 reveal isVisible' : 'section services2 reveal'} id="services" ref={ref}>
      <div className="container">
        <div className="services2Head">
          <h2 className="sectionTitle">We connect you with local food</h2>
          <p className="sectionLead">Restaurants, bars, pubs, tapris, cafés.</p>
        </div>

        <div className="services2Grid" role="list">
          {items.map((x) => (
            <div className="svcCard" key={x.title} role="listitem">
              <div className="svcIcon" aria-hidden="true">
                {x.icon}
              </div>
              <div className="svcTitle">{x.title}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
